// Design prefetch lean (flag REACT_APP_DESIGN_PREFETCH_LEAN_ENABLED, 28/9,
// PLAN-A9-PRISTOP-ARTBOARDS §E.3) - the pure decisions of whether a HIDDEN
// design list prefetch may fire. No flag reads here: the call sites pass
// enviroment.designPrefetchLeanEnabled / designPrefetchMaxTotal, so the rules
// are unit-tested without react-query or the screens.
//
// A visible design page for a large org (chain orgs 1,278-2,684 designs, org
// 1374 18,999) is one heavy GetDesigns; the next-page prefetch, the
// paginator hover and the logo list's cross-prefetch each add another one
// the user may never look at. The limit spares those for large results only;
// small orgs keep their instant next page. A click always fetches as today.

/**
 * Whether the design list may prefetch another page (next page after the
 * debounce, paginator hover) of the result it shows. Flag off, no usable
 * limit (<= 0) or an unknown total = true (today's behaviour); otherwise
 * only when the result's totalCount is within the limit.
 */
export function shouldPrefetchDesignPage(
  totalCount: number | undefined,
  maxTotal: number,
  enabled: boolean,
): boolean {
  if (!enabled) return true;
  if (!(maxTotal > 0)) return true;
  if (typeof totalCount !== "number" || !Number.isFinite(totalCount)) return true;
  return totalCount <= maxTotal;
}

/**
 * Whether the logo list may cross-prefetch the design list's first page.
 * cachedTotal is the totalCount of that page as the query cache already
 * holds it (never fetched to find out): unknown = true (today's behaviour),
 * as are flag off and no usable limit; otherwise only within the limit.
 */
export function shouldCrossPrefetchDesigns(
  cachedTotal: number | undefined,
  maxTotal: number,
  enabled: boolean,
): boolean {
  if (!enabled) return true;
  if (!(maxTotal > 0)) return true;
  if (typeof cachedTotal !== "number" || !Number.isFinite(cachedTotal)) return true;
  return cachedTotal <= maxTotal;
}
